// extracted by mini-css-extract-plugin
export default {"tag":"MultipleSelect_tag__WrfKR","dropdown":"MultipleSelect_dropdown__y7K1Y"};